<script>
import SegmentEvaluateDropdown from '@/modules/audiences/components/SegmentEvaluateDropdown'
export default {
  extends: SegmentEvaluateDropdown
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/RollingSegmentEvaluateDropdown.vue